import React from 'react';
import { RootRoute, Route, Router, Outlet } from '@tanstack/react-router';
import UnderConstructionPage from './components/UnderConstructionPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';

// Create root route
const rootRoute = new RootRoute({
  component: RootLayout,
});

function RootLayout() {
  return <Outlet />;
}

// Create home route
const indexRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/',
  component: UnderConstructionPage,
});

// Create privacy policy route
const privacyRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/privacy-policy',
  component: PrivacyPolicyPage,
});

// Create route tree
const routeTree = rootRoute.addChildren([indexRoute, privacyRoute]);

// Create router
export const router = new Router({ routeTree });

// Register router for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
